import { GET_DATA_PERMISSION_SUCCEEDED, REQUERT_DATA_PERMISSION_FAILED } from "../actions/actionsTypes";

const menuRoleReducer = (DataPermission = [], actions) => {
    switch (actions.type) {
        case GET_DATA_PERMISSION_SUCCEEDED:
            if(Object.keys(actions.DataPermission).length > 0){
                return {...DataPermission, DataPermission: actions.DataPermission};
            }
            else
            {
                return {...DataPermission, DataPermission: []};
            }
        case REQUERT_DATA_PERMISSION_FAILED:
            return {...DataPermission, DataPermission: []};
        default:
            return DataPermission;
    }
}

export default menuRoleReducer;